<!-- <div class="capitaland ">
  <div class="capitaland-wrapper"> -->
<!-- <app-meeting-rooms></app-meeting-rooms> -->
<!-- <app-trial></app-trial> -->
<!-- <app-side-nav></app-side-nav> -->
<!-- <router-outlet></router-outlet>
  </div>
</div> -->

<!-- <div class="capitaland-section" *ngIf="checkLoginSSO()">
  <div *ngIf="isLoggedTokenSaved$ | async">
    <app-side-nav *ngIf="isLoggedIn && showSidebar && checkLoginSSO()" class="side-nav"></app-side-nav>
    <div class="main" [ngClass]="{'loggedInStyle':(isLoggedIn && showSidebar && checkLoginSSO())}">
      <app-header *ngIf="isLoggedIn && showSidebar && checkLoginSSO()" class="header"></app-header>
      <div class="main-section">
        <toast #toastRef></toast>
        <router-outlet (activate)="refreshLocationApi()"></router-outlet>
        <notifications *ngIf="isLoggedIn && showSidebar && checkLoginSSO()"></notifications>
        <ng-http-loader [entryComponent]="LoaderComponent" [backdrop]="true" [debounceDelay]="100" [extraDuration]="0"
          [filteredUrlPatterns]="LoaderExcludes" [minDuration]="300" [opacity]=".4"
          [backdropBackgroundColor]="'#777777'">
        </ng-http-loader>
        <app-footer *ngIf="!hideFooter"></app-footer>
      </div>
    </div>
  </div>
</div>
<div class="capitaland-section" *ngIf="!checkLoginSSO()">
  <app-side-nav *ngIf="isLoggedIn && showSidebar" class="side-nav"></app-side-nav>
  <div class="main" [ngClass]="{'loggedInStyle':(isLoggedIn && showSidebar)}">
    <div class="main-section">
      <app-header *ngIf="isLoggedIn && showSidebar" class="header"></app-header>
      <toast #toastRef></toast>
      <router-outlet></router-outlet>
      <notifications *ngIf="isLoggedIn && showSidebar"></notifications>
      <ng-http-loader [entryComponent]="LoaderComponent" [backdrop]="true" [debounceDelay]="100" [extraDuration]="0"
        [filteredUrlPatterns]="LoaderExcludes" [minDuration]="300" [opacity]=".4" [backdropBackgroundColor]="'#777777'">
      </ng-http-loader>
      <app-footer *ngIf="!hideFooter"></app-footer>
    </div>
  </div>
</div> -->


<!-- <div class="capitaland-section" *ngIf="adminId">
  <app-side-nav *ngIf="isLoggedIn && showSidebar && checkLoginSSO()" class="side-nav"></app-side-nav>
  <div class="main" [ngClass]="{'loggedInStyle':(isLoggedIn && showSidebar && checkLoginSSO())}">
    <app-header *ngIf="isLoggedIn && showSidebar && checkLoginSSO()" class="header"></app-header>
    <div class="main-section">
      <toast #toastRef></toast>
      <router-outlet (activate)="refreshLocationApi()"></router-outlet>
      <notifications *ngIf="isLoggedIn && showSidebar && checkLoginSSO()"></notifications>
      <ng-http-loader [entryComponent]="LoaderComponent" [backdrop]="true" [debounceDelay]="100" [extraDuration]="0"
        [filteredUrlPatterns]="LoaderExcludes" [minDuration]="300" [opacity]=".4" [backdropBackgroundColor]="'#777777'">
      </ng-http-loader>
      <app-footer *ngIf="!hideFooter"></app-footer>
    </div>
  </div>
</div>
<div class="capitaland-section" *ngIf="!adminId && !token">
  <div class="main" [ngClass]="{'loggedInStyle':(isLoggedIn && showSidebar)}">
    <div class="main-section">
      <toast #toastRef></toast>
      <router-outlet></router-outlet>
      <ng-http-loader [entryComponent]="LoaderComponent" [backdrop]="true" [debounceDelay]="100" [extraDuration]="0"
        [filteredUrlPatterns]="LoaderExcludes" [minDuration]="300" [opacity]=".4" [backdropBackgroundColor]="'#777777'">
      </ng-http-loader>
      <app-footer *ngIf="!hideFooter"></app-footer>
    </div>
  </div>
</div> -->

<div class="capitaland-section" *ngIf="adminId">
  <app-side-nav *ngIf="adminId && showSidebar" class="side-nav"></app-side-nav>
  <div class="main" [ngClass]="{'loggedInStyle':(adminId && showSidebar)}">
    <app-header *ngIf="adminId && showSidebar" class="header"></app-header>
    <div class="main-section">
      <toast #toastRef></toast>
      <router-outlet (activate)="refreshLocationApi()"></router-outlet>
      <notifications *ngIf="adminId && showSidebar"></notifications>
      <ng-http-loader [entryComponent]="LoaderComponent" [backdrop]="true" [debounceDelay]="100" [extraDuration]="0"
        [filteredUrlPatterns]="LoaderExcludes" [minDuration]="300" [opacity]=".4" [backdropBackgroundColor]="'#777777'">
      </ng-http-loader>
      <app-footer *ngIf="adminId && showSidebar"></app-footer>
    </div>
  </div>
</div>
<div class="capitaland-section" *ngIf="!adminId && !token">
  <div class="main" [ngClass]="{'loggedInStyle':(adminId && showSidebar)}">
    <div class="main-section">
      <toast #toastRef></toast>
      <router-outlet></router-outlet>
      <ng-http-loader [entryComponent]="LoaderComponent" [backdrop]="true" [debounceDelay]="100" [extraDuration]="0"
        [filteredUrlPatterns]="LoaderExcludes" [minDuration]="300" [opacity]=".4" [backdropBackgroundColor]="'#777777'">
      </ng-http-loader>
      <app-footer *ngIf="adminId && showSidebar"></app-footer>
    </div>
  </div>
</div>